import React from 'react';

const Tentang = () => {
  return (
    <div className="w-full bg-slate-50 min-h-screen">
      {/* Header Halaman */}
      <div className="bg-emerald-700 text-white py-16 px-4 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-4">Tentang HEBITREN</h1>
        <p className="text-emerald-100 max-w-2xl mx-auto text-lg">
          Mengenal lebih dekat sejarah, visi, dan misi Himpunan Ekonomi Bisnis Pesantren.
        </p>
      </div>

      {/* Main Content Container */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16">

        {/* 1. Sejarah */}
        <section id="sejarah" className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-slate-100">
          <h2 className="text-2xl font-bold text-slate-800 mb-6 border-l-4 border-emerald-500 pl-4">Sejarah Pembentukan</h2>
          <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed">
            <p className="mb-4">
              Cikal bakal pembentukan Hebitren tidak lepas dari dukungan Bank Indonesia sejak Indonesia Sharia Economic Festival (ISEF) pertama pada tahun 2014 di Surabaya.
              Ide awal pembentukan ini terealisasi pada momentum Sarasehan 110 Pondok Pesantren terpilih dalam rangkaian ISEF ke-6 yang diselenggarakan oleh Bank Indonesia pada 12-16 November 2019 di Jakarta Convention Center (JCC).
              Pada tanggal 12 November 2019, 110 pesantren dari berbagai daerah tersebut mendeklarasikan inisiasi pembentukan usaha induk (holding bisnis) pesantren yang akan menaungi seluruh kegiatan perekonomian dan usaha pesantren.
            </p>
            <p>
              Sebagai milestone penting, HEBITREN secara resmi diluncurkan secara nasional pada momentum Kick Off ISEF ke-7 tanggal 7 Agustus 2020, dan disaksikan langsung oleh tokoh negara, yakni Wakil Presiden Republik Indonesia KH. Ma’ruf Amin.
              Pengesahan awal organisasi secara nasional kemudian diperkuat melalui Musyawarah Kerja Nasional (MUKERNAS) HEBITREN perdana pada Rangkaian Pembukaan Acara puncak ISEF ke-7 pada 27–31 Oktober 2020.
              Acara pengesahan tersebut menghadirkan tokoh-tokoh penting seperti Gubernur Bank Indonesia dan Menteri Agama RI, serta ribuan tamu undangan dari berbagai pondok pesantren maupun mitra strategis HEBITREN lainnya.
            </p>
          </div>
        </section>

        {/* 2. Visi & Misi */}
        <section id="visi-misi" className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-emerald-50 p-8 rounded-2xl border border-emerald-100">
            <h2 className="text-2xl font-bold text-emerald-900 mb-4">Visi</h2>
            <p className="text-emerald-800 font-medium leading-relaxed italic">
              Menjadi pilar utama penggerak ekonomi pesantren nusantara yang berdaya saing global, mandiri, dan berlandaskan nilai-nilai syariah.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100">
            <h2 className="text-2xl font-bold text-slate-800 mb-4">Misi</h2>
            <ul className="list-decimal list-outside ml-5 text-slate-600 space-y-3">
              <li>Mengembangkan jaringan bisnis antar pesantren</li>
              <li>Memfasilitasi inkubasi dan pendampingan unit usaha</li>
              <li>Mendorong standarisasi produk pesantren</li>
              <li>Membangun platform digital untuk akses pasar yang lebih luas</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Tentang;